import { useMutation } from '@tanstack/react-query';
import type {
	LWApiPublicEventMessageSendParamsRaw,
	LWApiPublicEventMessageSendResultRaw,
} from '@liquidweb-dev/club-sauce/public/eventmessage/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';

const useEventmessageSend = () => {
	const snackbarError = useSnackbarError();

	return useMutation<
		LWApiPublicEventMessageSendResultRaw,
		ApiErrorI,
		LWApiPublicEventMessageSendParamsRaw
	>({
		mutationFn: (params) => api.eventmessage.apiRaw.send(params),
		onError: snackbarError,
	});
};

export default useEventmessageSend;
